import type { ReactNode } from "react";
import type { PagerView } from "../lib/pager";
import { Pager } from "./Lcd";

/**
 * The top of every signed-in screen, in reading order: the pager with the screen's most important
 * message, one headline, an optional short line of facts, then the one action that matters.
 */
export function ScreenHead({
  pager,
  title,
  sub,
  live,
  children,
}: {
  pager: PagerView;
  title: ReactNode;
  sub?: ReactNode;
  /** Announce pager changes (e.g. setup going online). */
  live?: boolean;
  children?: ReactNode;
}) {
  return (
    <header className="head">
      <Pager size="sm" lines={pager.lines} tone={pager.tone} live={live} />
      <div className="head-text">
        <h1 className="h2">{title}</h1>
        {sub && <p className="head-sub">{sub}</p>}
        {children && <div className="head-act">{children}</div>}
      </div>
    </header>
  );
}
